import { yellow } from '@styles/colors';

import { AccountStrength, Milestone } from '../types';

const EMPLOYER_ROOT = '/employer/';

export const MILESTONES = [
  {
    id: 1,
    label: 'Complete company information',
    complete: false,
    url: `${EMPLOYER_ROOT}account/#Company-Profile`,
    subproperties: [
      {
        id: 1,
        label: 'Location',
        complete: false,
        completionProperty: 'has_address',
      },
      {
        id: 2,
        label: 'Company Logo',
        complete: false,
        completionProperty: 'has_image',
      },
      {
        id: 3,
        label: 'Background Image',
        complete: false,
        completionProperty: 'has_cover_image',
      },
    ],
  },
  {
    id: 2,
    label: 'Job Position Posted',
    complete: false,
    completionProperty: 'has_job_postings',
    description: "(don't forget pay rate)",
    url: `${EMPLOYER_ROOT}positions/`,
  },
  {
    id: 3,
    label: 'Add applications questions to qualify candidates automatically',
    complete: false,
    completionProperty: 'has_application_questions',
    url: `${EMPLOYER_ROOT}application-questions/`,
  },
  {
    id: 4,
    label: 'Add payment information & select plan',
    complete: false,
    completionProperty: 'has_payment_method',
    url: `${EMPLOYER_ROOT}account/#Manage-Billing`,
  },
  {
    id: 5,
    label: 'Hiring link added to website',
    complete: false,
    completionProperty: 'has_shared_page',
    description:
      'This one’s super important! External job boards like Google Jobs and Indeed will verify and promote your jobs more when they’ve confirmed that your StaffedUp hiring link is active on your website.',
    url: `${EMPLOYER_ROOT}account/#Add-To-Website`,
    rows: 2,
  },
  {
    id: 6,
    label: 'Post jobs to social media',
    complete: false,
    url: `${EMPLOYER_ROOT}account/#Company-Profile`,
    completionProperty: 'has_social_image',
  },
] as Milestone[];

export const STRENGTH_LEVELS = [
  {
    label: 'Mediocre at best...',
    color: 'error.main',
  },
  {
    label: 'Good but not great...',
    color: `${yellow}`,
  },
  {
    label: 'You’re killing it!',
    color: 'success.main',
  },
] as AccountStrength[];

export const stepsArray = [
  {
    completionProperty: 'has_job_postings',
  },
  {
    completionProperty: 'has_job_postings',
  },
  {
    completionProperty: 'has_application_questions',
  },
  {
    completionProperty: 'has_payment_method',
  },
  {
    completionProperty: 'has_payment_method',
  },
];